export default {
  // Navigation & General
  appName: "مستشار النمو الذكي",
  appTagline: "تتبع رحلة نمو طفلك",
  language: "اللغة",
  arabic: "العربية",
  english: "English",
  languageName: "العربية",
  next: "التالي",
  back: "العودة",
  submit: "إرسال",
  cancel: "إلغاء",
  close: "إغلاق",
  watchVideo: "شاهد كيف",
  loading: "جاري التحميل...",
  processing: "جاري تحليل نمو طفلك...",
  viewReport: "عرض التقرير",
  addToCart: "أضف للسلة",
  lowStock: "الكمية محدودة",
  sar: "ر.س",
  save: "حفظ",
  fillAllFields: "يرجى تعبئة جميع الحقول",
  validEmailRequired: "يرجى إدخال بريد إلكتروني صالح",
  genericErrorRetry: "حدث خطأ. يرجى المحاولة لاحقاً",
  emailOrPhone: "البريد الإلكتروني أو رقم الجوال",
  emailOrPhonePlaceholder: "example@domain.com أو 05xxxxxxxx",
  password: "كلمة المرور",
  login: "تسجيل الدخول",
  loggingIn: "جاري تسجيل الدخول...",
  logout: "تسجيل الخروج",
  register: "تسجيل جديد",
  registerNow: "سجل الآن كولي أمر",
  noAccount: "ليس لديك حساب؟",
  parentLoginTitle: "تسجيل الدخول لولي الأمر",
  parentRegisterTitle: "إنشاء حساب ولي أمر",
  fullName: "الاسم الكامل",
  fullNamePlaceholder: "مثلا: محمد العلي",
  invalidEmailAddress: "البريد الإلكتروني غير صالح",
  passwordMinError: "كلمة المرور يجب أن تكون 6 أحرف على الأقل",
  registrationFailed: "فشل التسجيل. يرجى التحقق من البيانات",
  creatingAccount: "جاري إنشاء الحساب...",
  createAccount: "إنشاء الحساب",
  alreadyHaveAccount: "لديك حساب بالفعل؟",
  showPassword: "إظهار كلمة المرور",
  hidePassword: "إخفاء كلمة المرور",
  invalidCredentials: "بيانات الدخول غير صحيحة",
  forgotPassword: "نسيت كلمة المرور؟",
  toggleTheme: "تبديل المظهر",
  languageAndTheme: "اللغة والمظهر",
  personalAccount: "حسابي الشخصي",
  forgotPasswordTitle: "نسيت كلمة المرور",
  resetLinkSentTitle: "تم إرسال الرابط بنجاح!",
  resetLinkSentDesc: "تم إرسال رابط إعادة تعيين كلمة المرور إلى بريدك الإلكتروني. يرجى التحقق من صندوق الوارد.",
  resetLinkValidity: "الرابط صالح لمدة 15 دقيقة فقط",
  backToLogin: "العودة لتسجيل الدخول",
  forgotPasswordDesc: "أدخل بريدك الإلكتروني وسنرسل لك رابطاً لإعادة تعيين كلمة المرور",
  emailAddress: "البريد الإلكتروني",
  sending: "جاري الإرسال...",
  sendResetLink: "إرسال رابط إعادة التعيين",
  rememberPassword: "تذكرت كلمة المرور؟",
  resetPasswordTitle: "إعادة تعيين كلمة المرور",
  resetPasswordDesc: "الرجاء إدخال كلمة المرور الجديدة لحسابك",
  resetTokenMissing: "رمز إعادة التعيين مفقود أو غير صالح",
  resetTokenMissingWarning: "تنبيه: رمز إعادة التعيين غير موجود في الرابط",
  resetPasswordFailed: "تعذر إعادة تعيين كلمة المرور. قد تكون صلاحية الرابط منتهية",
  passwordsDoNotMatch: "كلمتا المرور غير متطابقتين",
  passwordChangedSuccess: "تم تغيير كلمة المرور بنجاح!",
  passwordChangedDesc: "يمكنك الآن تسجيل الدخول إلى حسابك باستخدام كلمة المرور الجديدة.",
  goHomeToLogin: "الذهاب للرئيسية لتسجيل الدخول",
  newPassword: "كلمة المرور الجديدة",
  confirmNewPassword: "تأكيد كلمة المرور الجديدة",
  savePassword: "حفظ كلمة المرور",
  parentNameRequired: "اسم ولي الأمر مطلوب",
  validPhoneRequired: "رقم الجوال غير صالح",
  validEmailMandatory: "البريد الإلكتروني إلزامي وغير صالح",
  accountPasswordRequired: "كلمة المرور مطلوبة وتتكون من 6 أحرف على الأقل",
  childNameRequired: "اسم الطفل مطلوب",
  childDobRequired: "تاريخ الميلاد مطلوب",
  selectChildRequired: "يرجى اختيار طفل",
  parentDefaultName: "ولي الأمر",
  phoneAlreadyRegistered: "رقم الهاتف هذا مسجل بالفعل لحساب آخر",
  emailAlreadyRegistered: "البريد الإلكتروني هذا مسجل بالفعل لحساب آخر",
  saveReportFailed: "تعذر حفظ التقرير. يرجى التحقق من المدخلات",
  savePrintReport: "حفظ التقرير وطباعته",
  reportSavedSuccess: "تم حفظ التقرير بنجاح!",
  selectChildForReport: "اختر طفلاً لربطه بهذا التقرير",
  addNewChildForReport: "إضافة طفل جديد لهذا التقرير",
  newAccountPassword: "كلمة مرور الحساب الجديد",
  childInformation: "بيانات الطفل",
  saveReportAccountNote: "بالمتابعة، ستحفظ هذا التقرير في حسابك تلقائياً للرجوع إليه، وإضافة أطفال آخرين لاحقاً.",
  saving: "جاري الحفظ...",
  saveReportLinkAccount: "حفظ التقرير والربط بالحساب",
  viewFinalReport: "عرض التقرير النهائي",
  addAnotherChildStartAssessment: "أضف طفلاً آخر وابدأ التقييم له",
  requiredFieldsMissing: "يرجى تعبئة جميع الحقول المطلوبة",
  addChildFailed: "تعذر إضافة الطفل. يرجى المحاولة لاحقاً",
  profileFieldsRequired: "يرجى ملء كافة الحقول",
  emailOrPhoneAlreadyUsed: "البريد الإلكتروني أو رقم الهاتف مستخدم بالفعل",
  updateChildFailed: "تعذر تعديل بيانات الطفل. يرجى المحاولة لاحقاً",
  customAssessment: "تقييم مخصص",
  recommendedGrowthTip: "نصيحة نمو مقترحة",
  recommendedGrowthTipMessage: "جرب إشراك {{name}} في الألعاب التفاعلية والأنشطة المناسبة لسنه لتطوير مهاراته المعرفية والاجتماعية.",
  amazingMilestone: "إنجاز رائع!",
  amazingMilestoneMessage: "تهانينا! حقق {{name}} مستوى تطور ممتاز في تقييمه الأخير. استمر بالدعم والتشجيع.",
  name: "الاسم",
  email: "البريد الإلكتروني",
  phoneNumber: "رقم الجوال",
  editDetails: "تعديل البيانات",
  noChildrenAdded: "لم تقم بإضافة أطفال بعد.",
  editChildInfo: "تعديل بيانات الطفل",
  adding: "جاري الإضافة...",
  saveChanges: "حفظ التغييرات",
  yearSingular: "سنة",
  yearPlural: "سنوات",
  monthSingular: "شهر",
  monthPlural: "أشهر",
  and: "و",
  countrySaudiArabia: "السعودية",
  countryUae: "الإمارات",
  countryKuwait: "الكويت",
  countryQatar: "قطر",
  countryBahrain: "البحرين",
  countryOman: "عمان",
  countryJordan: "الأردن",
  countryEgypt: "مصر",
  countryLebanon: "لبنان",
  countrySyria: "سوريا",
  countryIraq: "العراق",
  countryPalestine: "فلسطين",
  countryMorocco: "المغرب",
  countryTunisia: "تونس",
  countryAlgeria: "الجزائر",
  countrySudan: "السودان",
  countrySomalia: "الصومال",
  countryYemen: "اليمن",
  countryUsa: "أمريكا",
  countryUk: "بريطانيا",

  // Landing Page
  heroTitle: "اكتشف إمكانيات نمو طفلك",
  heroSubtitle: "أداة تقييم ذكية تساعدك على فهم تطور طفلك عبر الأبعاد البدنية والمعرفية والاجتماعية.",
  selectAge: "اختر الفئة العمرية لطفلك",
  ageGroup: "الفئة العمرية",
  months: "شهراً",
  years: "سنوات",
  startAssessment: "ابدأ التقييم",
  howItWorks: "كيف يعمل",
  step1Title: "اختر العمر",
  step1Desc: "اختر فئة عمر طفلك للحصول على تقييم مهارات مخصص.",
  step2Title: "قيّم المهارات",
  step2Desc: "حدد المهارات التي أتقنها طفلك عبر أركان التطور الثلاثة.",
  step3Title: "احصل على رؤى",
  step3Desc: "احصل على تقرير مفصل مع أشرطة التطور وتوصيات المنتجات.",

  // Assessment Page
  assessmentTitle: "تقييم المهارات",
  assessmentSubtitle: "حدد المهارات التي أتقنها طفلك. اضغط على أيقونة الفيديو لرؤية الأمثلة.",
  physical: "التطور البدني",
  cognitive: "التطور المعرفي",
  social: "التطور الاجتماعي والعاطفي",
  skillMastered: "أتقنها",
  skillNotMastered: "لم يتقنها بعد",
  progress: "التقدم",
  of: "من",
  skillsChecked: "مهارة محددة",
  completeAssessment: "تحقق",

  // Processing
  processingTitle: "جاري بناء التقرير",
  processingSubtitle: "يقوم النظام بتحليل بيانات التقييم لإنشاء تقرير تطور مخصص...",

  // Lead Capture
  leadTitle: "اكتمل التقييم بنجاح!",
  leadSubtitle: "لحفظ التقرير، مشاهدة الأشرطة الملونة، واستعراض الألعاب المقترحة لتنمية مهارات طفلك، يرجى إدخال البيانات التالية:",
  childName: "اسم الطفل",
  childNamePlaceholder: "مثلاً: الطفل الأول",
  dob: "تاريخ الميلاد",
  gender: "الجنس",
  male: "ذكر",
  female: "أنثى",
  parentPhone: "رقم جوال الأم/الأب",
  parentEmail: "البريد الإلكتروني",
  emailPlaceholder: "لإرسال التقرير",
  addAnotherChild: "أضف طفلاً آخر",
  generateReport: "عرض التقرير",
  privacyNote: "معلوماتك آمنة وستُستخدم فقط لإرسال تقرير التطور.",

  // Report Page
  reportTitle: "تقرير التطور",
  reportSubtitle: "رؤى نمو مخصصة لـ",
  developmentOverview: "نظرة عامة على التطور",
  physicalScore: "البدني",
  cognitiveScore: "المعرفي",
  socialScore: "الاجتماعي والعاطفي",
  developmentStatus: "حالة التطور",
  excellent: "ممتاز",
  good: "جيد",
  developing: "قيد التطور",
  needsAttention: "يحتاج اهتماماً",
  recommendedProducts: "المنتجات المقترحة",
  readyToPurchase: "جاهز للشراء؟",
  checkoutDescription: "أرسل المنتجات المقترحة المتوفرة إلى صفحة الدفع في المتجر.",
  goToCheckout: "الانتقال إلى الدفع",
  processingCheckout: "جاري تجهيز الدفع...",
  noProductsAvailable: "لا توجد منتجات متاحة للدفع",
  checkoutCreateFailed: "تعذر إنشاء جلسة الدفع",
  noProductsInStock: "لا توجد منتجات مقترحة متوفرة في المخزون",
  secureCheckoutMessage: "سيتم إرسال المنتجات إلى سلة المتجر، ويمكن للعميل إكمال الطلب من هناك.",
  productsSubtitle: "منتجات تساعد على سد فجوات التطور",
  noProducts: "لا توجد منتجات متاحة لهذه الفئة حالياً.",
  productAvailable: "المتوفر",
  productInCart: "في السلة",
  productOutOfStock: "غير متوفر حاليا",
  productQuantity: "كمية المنتج",
  decreaseQuantity: "تقليل الكمية",
  increaseQuantity: "زيادة الكمية",
  addProductToCart: "إضافة المنتج للسلة",
  removeProductFromCart: "حذف المنتج من السلة",
  suggestedProductsCart: "سلة المنتجات المقترحة",
  suggestedProductsCartHint: "يمكنك اختيار المنتجات المناسبة فقط، أو إضافة كل المنتجات المقترحة ثم تعديل الكميات أو حذف أي منتج قبل الانتقال إلى سلة المتجر.",
  addAllProducts: "إضافة كل المنتجات",
  cartEmpty: "السلة فارغة",
  cartEmptyHint: "أضف منتجا من الاقتراحات أو استخدم زر إضافة كل المنتجات.",
  cartItems: "عدد المنتجات",
  cartPieces: "عدد القطع",
  cartTotal: "الإجمالي",
  cartShipping: "التوصيل",
  checkoutInSalla: "فتح السلة في المتجر",
  checkoutInStore: "فتح السلة في {{storeName}}",
  checkoutCreatePaymentRequest: "إرسال طلب دفع",
  checkoutPaymentRequestCreated: "تم إرسال طلب الدفع بنجاح. سيقوم فريقنا بمراجعة المنتجات وإرسال رابط الدفع لاحقا.",
  checkoutCreateSallaOrder: "إنشاء طلب في المتجر",
  checkoutSallaOrderCreated: "تم إنشاء الطلب في المتجر بنجاح. سيقوم فريقنا بمراجعة الطلب وإرسال رابط الدفع لاحقا.",
  sallaStoreFallback: "المتجر",
  checkoutPrepareFailed: "تعذر تجهيز السلة حاليا. تأكد من إعدادات ربط المتجر ثم حاول مرة أخرى.",
  loadingProductOptions: "جاري تحميل خيارات المنتج...",
  productOptionPlaceholder: "اختر",
  productOptionsRequired: "يرجى اختيار خيارات المنتج المطلوبة قبل إنشاء الطلب.",
  storeOrderShippingRequired: "اختر عنوان التوصيل وشركة توصيل متاحة قبل إنشاء الطلب.",
  checkoutShippingAddress: "عنوان التوصيل",
  checkoutShippingAddressHint: "اختر عنوانا محفوظا أو أضف عنوانا جديدا. سيتم جلب أسعار التوصيل من المتجر حسب هذا العنوان.",
  checkoutAddNewAddress: "إضافة عنوان",
  checkoutSavedAddress: "عنوان محفوظ",
  checkoutDefaultAddress: "افتراضي",
  checkoutAddressLabel: "اسم العنوان، مثلا المنزل",
  checkoutRecipientName: "اسم المستلم",
  checkoutRecipientPhone: "جوال المستلم",
  checkoutAddressSearch: "ابحث عن العنوان عبر خرائط Google",
  checkoutAddressSearchDisabled: "أضف مفتاح Google Maps لتفعيل البحث عن العنوان",
  checkoutUseCurrentLocation: "استخدام موقعي الحالي",
  checkoutLocationLoading: "جاري تحديد الموقع...",
  checkoutLocationUnsupported: "المتصفح لا يدعم تحديد الموقع.",
  checkoutLocationDenied: "تعذر تحديد موقعك. اسمح بالوصول للموقع ثم حاول مرة أخرى.",
  checkoutGoogleMapsLoadFailed: "تعذر تحميل خرائط Google حاليا. يمكنك إدخال العنوان أو استخدام الموقع الحالي.",
  checkoutCountryId: "الدولة",
  checkoutCityId: "المدينة",
  checkoutCountry: "الدولة",
  checkoutCity: "المدينة",
  checkoutDistrict: "الحي",
  checkoutLocationsLoading: "جاري تحميل المواقع...",
  checkoutLocationsLoadFailed: "تعذر تحميل الدول والمدن من المتجر. تأكد من تفعيل صلاحية Metadata Read في التطبيق.",
  checkoutDistrictsLoadFailed: "تعذر تحميل الأحياء من المتجر. يمكنك كتابة اسم الحي يدويا.",
  checkoutDistrictId: "معرف الحي",
  checkoutDistrictName: "اسم الحي",
  checkoutAddressLine1: "عنوان التوصيل",
  checkoutAddressDetails: "تفاصيل العنوان",
  checkoutStreetNumber: "رقم الشارع",
  checkoutGeoCoordinates: "الإحداثيات، مثال 24.7136,46.6753",
  checkoutPostalCode: "الرمز البريدي",
  checkoutSaveAddress: "حفظ العنوان",
  checkoutAddressSaveFailed: "تعذر حفظ العنوان حاليا. تأكد أن التقرير محفوظ ثم حاول مرة أخرى.",
  checkoutAddressRequired: "أدخل الدولة والمدينة وعنوان التوصيل أولا.",
  checkoutShippingAddressDetailsRequired: "أدخل اسم الحي ورقم الشارع والإحداثيات لأن شركة الشحن المختارة تطلبها.",
  checkoutShippingCompany: "شركة التوصيل",
  shippingRatesLoading: "جاري تحميل شركات التوصيل...",
  shippingRatesLoadFailed: "لا توجد شركات توصيل متاحة لهذا العنوان حاليا. تحقق من صلاحية الشحن وشركات التوصيل المفعلة في المتجر.",
  shippingPermissionRequired: "لا يمكن جلب شركات التوصيل لأن التطبيق لا يملك صلاحية الشحن من المتجر. سيتم إنشاء طلب مسودة داخل المتجر بدون شركة شحن.",
  shippingRateRequired: "اختر شركة توصيل",
  manualPaymentRequestMessage: "سيتم إرسال المنتجات المختارة إلى لوحة التحكم لمراجعتها وإرسال رابط الدفع للعميل لاحقا.",
  sallaOrderRequestMessage: "سيتم إنشاء طلب في المتجر بعد اختيار عنوان العميل وشركة التوصيل المتاحة.",
  reportEmailSendFailed: "تم حفظ التقرير، لكن تعذر إرسال النسخة البريدية حاليا بسبب إعدادات أو خدمة البريد.",
  loginRequiredToEmailReport: "يرجى تسجيل الدخول أولاً لإرسال التقرير",
  reportEmailSentSuccess: "تم إرسال التقرير إلى بريدك الإلكتروني بنجاح!",
  temporaryReportTitle: "تقرير مؤقت لنتائج تقييم طفلك",
  temporaryReportHint: "لحفظ التقرير وإضافته لملف طفلك الدائم والوصول إليه لاحقاً، يرجى إكمال التسجيل.",
  saveReportRegisterChild: "حفظ التقرير وتسجيل طفلك",
  noMasteredSkillsInCategory: "لا توجد مهارات متقنة بعد في هذا الركن.",
  allSkillsMasteredInCategory: "عمل رائع! تم إتقان جميع مهارات هذا الركن.",
  sendViaEmail: "إرسال عبر البريد",
  resetEmailSendFailed: "تعذر إرسال رابط الاستعادة حاليا بسبب إعدادات أو خدمة البريد.",
  shareReport: "مشاركة التقرير",
  printReport: "طباعة التقرير",
  retakeAssessment: "إعادة التقييم",

  // Age Groups
  age0_6: "0 - 6 أشهر",
  age0_6Subtitle: "مرحلة الاكتشاف",
  age7_12: "7 - 12 شهراً",
  age7_12Subtitle: "مرحلة الاستكشاف",
  age1_2: "1 - 2 سنة",
  age1_2Subtitle: "مرحلة الاستقلالية",
  age2_3: "2 - 3 سنوات",
  age2_3Subtitle: "مرحلة الانطلاق",
  age3_4: "3 - 4 سنوات",
  age3_4Subtitle: "مرحلة الخيال",
  age4_5: "4 - 5 سنوات",
  age4_5Subtitle: "مرحلة المنطق",
  age5_6: "5 - 6 سنوات",
  age5_6Subtitle: "الاستعداد المدرسي",

  // Landing Page - Hardcoded translations
  trustedBy: "موثوق من +5000 عائلة",
  smartAssessment: "تقييم ذكي",
  threePillarsShort: "3 أركان للتطور",
  methodologySubtitle: "منهجية علمية مبنية على الأركان الثلاثة للتعلم",
  threePillarsTitle: "أركان التطور الثلاثة",
  threePillarsDesc: "يعتمد التقييم على خوارزمية تصنف نمو طفلك بناءً على الأركان الأساسية للتعلم",
  physicalDesc: "يبدأ بالمهارات الحركية الكبرى والدقيقة، ويتطور للتآزر البصري الحركي واستخدام الأدوات",
  cognitiveDesc: "يبدأ بالاستجابة للأصوات والسبب والنتيجة، ويتطور للتفكير المنطقي والإبداع",
  socialDesc: "يبدأ بالابتسام والتعلق، ويتطور للتعاون وفهم القواعد والتعاطف",
  selectAgeSubtitle: "اختر الفئة المناسبة لعمر طفلك لبدء التقييم",
  ctaTitle: "ابدأ رحلة التطور مع طفلك اليوم",

  // Assessment
  ageGroupNotFound: "الفئة العمرية غير موجودة",
  reportNotFound: "التقرير غير موجود",
  dataLoadFailed: "تعذر تحميل البيانات",
  noData: "لا توجد بيانات",
  notAvailable: "غير متوفر",

  // Report
  yourChild: "طفلك",
  assessedSummary: "تم تقييم {{checked}} من {{total}} مهارة. {{status}} في التطور العام.",

  // NotFound
  pageNotFound: "الصفحة غير موجودة",
  pageNotFoundDesc: "عذراً، الصفحة التي تبحث عنها غير متوفرة. ربما تم نقلها أو حذفها.",
  backToHome: "العودة للرئيسية",

  // Report - Skills & Products
  skillsToDevelop: "المهارات التي تحتاج للتطوير",
  skillsToDevelopDesc: "كل مهارة مفقودة مع منتجات مناسبة للتدريب",
  masteredSkillsTitle: "المهارات المتقنة",
  masteredSkillsDesc: "كل مهارة متقنة مع منتجات لتعزيز الإبداع",
  suggestedProducts: "منتجات مقترحة للتدريب",
  creativityProducts: "منتجات لتعزيز الإبداع",
  skills: "مهارات",

  // Lead Capture Modal
  printReportTitle: "اطبع التقرير",
  printReportDesc: "سجل بياناتك لحفظ التقرير والوصول إليه لاحقاً",
  parentName: "اسم ولي الأمر",
  parentNamePlaceholder: "مثلاً: محمد العلي",
  verifyPhone: "تحقق من رقم الجوال",
  otpSentTo: "تم إرسال رمز التحقق إلى",
  enterOtp: "أدخل رمز التحقق",
  otpSentDesc: "أدخل الرمز المكون من 4 أرقام المرسل إلى",
  changePhone: "تغيير رقم الجوال",
  confirmOtp: "تأكيد الرمز",
  verifyAndContinue: "تحقق واستمر",
  requiredField: "هذا الحقل مطلوب",
  invalidPhone: "رقم جوال غير صالح",
  invalidEmail: "بريد إلكتروني غير صالح",
  invalidOtp: "رمز التحقق غير صالح",
  phonePlaceholder: "5X XXX XXXX",
  accountNote: "سيتم إنشاء حساب في المنصة تلقائياً. يمكنك الرجوع للتقارير مستقبلاً وإضافة أطفال آخرين.",

  // Admin
  adminTitle: "لوحة الإدارة",
  adminWelcome: "مرحباً {{name}}",
  adminLoginTitle: "تسجيل دخول الإدارة",
  adminLoginSubtitle: "سجل الدخول لإدارة المحتوى والصلاحيات",
  adminEmail: "البريد الإلكتروني",
  adminEmailPlaceholder: "example@domain.com",
  adminPassword: "كلمة المرور",
  adminPasswordPlaceholder: "••••••••",
  adminSignIn: "تسجيل الدخول",
  adminLoggingIn: "جاري تسجيل الدخول",
  adminInvalidCredentials: "بيانات الدخول غير صحيحة",
  adminRememberMe: "تذكرني",
  adminLogout: "تسجيل الخروج",
  adminDashboard: "لوحة التحكم",
  adminAgeGroups: "الفئات العمرية",
  adminCategories: "الأركان",
  adminSkills: "المهارات",
  adminProducts: "منتجات المتجر",
  adminOrders: "طلبات المتجر",
  adminMappings: "ربط المنتجات",
  adminCrm: "قاعدة العملاء",
  adminParents: "الأهالي",
  adminChildren: "الأطفال",
  adminReports: "التقارير",
  adminName: "اسم المشرف",
  adminOverview: "ملخص الأداء",
  adminTotalAgeGroups: "عدد الفئات العمرية",
  adminTotalCategories: "عدد الأركان",
  adminTotalSkills: "عدد المهارات",
  adminTotalProducts: "عدد المنتجات",
  adminTotalParents: "عدد الأهالي",
  adminTotalChildren: "عدد الأطفال",
  adminTotalReports: "عدد التقارير",
  adminAgeGroupKey: "المفتاح",
  adminAgeGroupName: "اسم الفئة",
  adminAgeGroupRange: "النطاق العمري",
  adminAgeGroupManageHint: "أضف أو حدّث الفئات العمرية مع ترجماتها",
  adminAddAgeGroup: "إضافة فئة عمرية",
  adminEditAgeGroup: "تعديل الفئة العمرية",
  adminClose: "إغلاق",
  adminTranslationValue: "نص الترجمة",
  adminTranslationHint: "اختر اللغة وادخل النص. إذا كانت لغة ثانوية فارغة سيتم تعبئتها تلقائياً من اللغة الافتراضية.",
  adminTranslations: "الترجمات",
  adminLocales: "اللغات",
  adminStatus: "الحالة",
  adminActions: "إجراءات",
  adminMinMonths: "الحد الأدنى بالأشهر",
  adminMaxMonths: "الحد الأعلى بالأشهر",
  adminTranslationLabel: "ترجمة {{language}}",
  adminCreate: "إضافة",
  adminUpdate: "تحديث",
  adminCancel: "إلغاء",
  adminEdit: "تعديل",
  adminDisable: "تعطيل",
  adminEnable: "تفعيل",
  adminFillRequired: "يرجى تعبئة الحقول الأساسية",
  adminFillTranslations: "يرجى إدخال ترجمة واحدة على الأقل",
  adminSaveFailed: "تعذر حفظ البيانات",
  adminCategoryKey: "مفتاح الركن",
  adminCategoryName: "اسم الركن",
  adminCategoryColor: "اللون",
  adminCategoryManageHint: "أضف أو حدّث الأركان مع ترجماتها",
  adminAddCategory: "إضافة ركن",
  adminEditCategory: "تعديل الركن",
  adminCategoryIcon: "أيقونة الركن",
  adminSkillKey: "مفتاح المهارة",
  adminSkillId: "معرف المهارة",
  adminSkillName: "اسم المهارة",
  adminSkillTitle: "اسم المهارة",
  adminSkillAgeGroup: "الفئة",
  adminSkillCategory: "الركن",
  adminSkillStatus: "الحالة",
  adminSkillManageHint: "أضف أو حدّث المهارات مع ترجماتها",
  adminAddSkill: "إضافة مهارة",
  adminEditSkill: "تعديل المهارة",
  adminSkillIcon: "أيقونة المهارة",
  adminSkillVideoUrl: "رابط الفيديو",
  adminSkillSearch: "بحث",
  adminSkillSearchPlaceholder: "ابحث باسم المهارة أو الركن أو الفئة",
  adminFilterCategory: "الركن",
  adminFilterAgeGroup: "الفئة",
  adminFilterStatus: "الحالة",
  adminAll: "الكل",
  adminRowsPerPage: "عدد النتائج",
  adminResultsCount: "النتائج: {{count}}",
  adminExportSkills: "تصدير المهارات",
  adminExporting: "جاري التصدير",
  adminNoData: "لا توجد بيانات",
  adminNoResults: "لا توجد نتائج",
  adminPageStatus: "صفحة {{current}} من {{total}}",
  adminPrevPage: "السابق",
  adminNextPage: "التالي",
  adminSettings: "إعدادات لوحة التحكم",
  adminSettingsHint: "إدارة صلاحيات المشرفين، الهوية، الألوان، البريد، والسيو",
  adminSettingsTabAdmins: "المشرفون",
  adminSettingsTabSmtp: "SMTP",
  adminSettingsTabBranding: "الهوية",
  adminSettingsTabTheme: "الثيم والألوان",
  adminSettingsTabSeo: "السيو",
  adminRole: "الصلاحية",
  adminRoleSuper: "مدير عام",
  adminRoleEditor: "محرر محتوى",
  adminPasswordOptional: "اتركها فارغة إذا لم ترغب بالتغيير",
  adminPasswordMin: "كلمة المرور يجب أن تكون 6 أحرف على الأقل",
  adminSaveSuccess: "تم حفظ الإعدادات بنجاح",
  adminSaveSettings: "حفظ الإعدادات",
  adminStatusActive: "الحساب مفعل",
  adminSiteName: "اسم الموقع",
  adminSiteTagline: "وصف مختصر",
  adminLogoUrl: "شعار الموقع",
  adminFaviconUrl: "أيقونة المتصفح",
  adminPrimaryColor: "اللون الأساسي",
  adminSecondaryColor: "اللون الثانوي",
  adminAccentColor: "لون مساعد",
  adminFontFamily: "الخط",
  adminSeoTitle: "عنوان الصفحة الرئيسية",
  adminSeoDescription: "وصف الصفحة الرئيسية",
  adminSeoKeywords: "كلمات مفتاحية",
  adminSeoOgImage: "صورة المشاركة",
  adminSmtpEnabled: "تفعيل SMTP",
  adminSmtpHost: "SMTP Host",
  adminSmtpSecurity: "نوع الاتصال",
  adminSmtpSecurityTls: "TLS",
  adminSmtpSecuritySsl: "SSL",
  adminSmtpAllowSelfSigned: "السماح بشهادة غير موثوقة",
  adminSmtpPort: "SMTP Port",
  adminSmtpUser: "SMTP User",
  adminSmtpPassword: "SMTP Password",
  adminSmtpFromName: "اسم المرسل",
  adminSmtpFromEmail: "بريد المرسل",
  adminSmtpTestEmail: "بريد الاختبار",
  adminSmtpTestButton: "اختبار الإرسال",
  adminSmtpTestSuccess: "تم إرسال رسالة الاختبار بنجاح",
  adminSmtpTestFailed: "فشل اختبار SMTP",
  adminSmtpPresetGmail: "جيميل",
  adminSmtpPresetMicrosoft: "مايكروسوفت",
  adminSmtpPresetYahoo: "ياهو",
  adminSmtpPresetIcloud: "آي كلاود",
  adminSmtpPresetZoho: "زوهو",
  adminSmtpPresetHint: "يضبط المضيف والمنفذ ونوع الاتصال",
  adminVisitWebsite: "زيارة الموقع",
  adminSallaTab: "المتجر",
  adminNotSet: "غير محدد",
  adminEveryMinutes: "كل {{count}} دقائق",
  adminEveryHours: "كل {{count}} ساعة",
  adminSallaDisconnectConfirm: "سيتم حذف توكنات وربط المتجر الحالي وإيقاف المزامنة. لن يتم حذف المنتجات. هل تريد المتابعة؟",
  adminSallaDisconnectSuccess: "تم فصل ربط المتجر بنجاح",
  adminSallaDisconnectFailed: "فشل فصل ربط المتجر",
  adminSallaConnectionStatus: "حالة ربط المتجر",
  adminSallaNoConnection: "لا يوجد متجر مربوط حاليا.",
  adminSallaDisconnect: "فصل ربط المتجر",
  adminSallaAutoSync: "تفعيل المزامنة التلقائية",
  adminSallaAutoSyncHint: "عند التفعيل سيتم تحديث منتجات المتجر حسب الفترة المحددة.",
  adminSallaCheckoutRedirectMode: "طريقة إرسال المنتجات بعد التوصية",
  adminSallaCheckoutRedirectModeHint: "اختر هل يفتح العميل سلة المتجر، أو ينتقل لمسار الدفع، أو يتم حفظ طلب داخلي، أو يتم إنشاء طلب فعلي في المتجر.",
  adminSallaRedirectToCart: "إرسال المنتجات إلى سلة المتجر",
  adminSallaRedirectToCartHint: "الخيار الافتراضي للتجربة؛ يتيح للعميل مراجعة المنتجات قبل إكمال الطلب.",
  adminSallaRedirectToCheckout: "إنشاء الدفع مباشرة",
  adminSallaRedirectToCheckoutHint: "يفتح رابط الدفع الذي يرجعه المتجر بعد تجهيز السلة.",
  adminSallaRedirectToPaymentRequest: "طلب دفع من لوحة التحكم",
  adminSallaRedirectToPaymentRequestHint: "يحفظ المنتجات كطلب داخلي حتى تراجعها الإدارة وترسل رابط الدفع لاحقا.",
  adminSallaRedirectToSallaOrder: "إنشاء طلب في المتجر",
  adminSallaRedirectToSallaOrderHint: "ينشئ طلبا فعليا في المتجر ويحفظ روابط الطلب للمراجعة والإرسال لاحقا.",
  adminSallaOrderPaymentMethod: "طريقة الدفع عند إنشاء طلب المتجر",
  adminSallaOrderPaymentMethodPlaceholder: "اختر طريقة دفع مفعلة",
  adminSallaOrderPaymentMethodHint: "تظهر هنا طرق الدفع الإلكترونية المفعلة فقط. اختر الطريقة التي سيستخدمها المتجر عند إنشاء الطلب.",
  adminSallaOrderPaymentMethodRequired: "اختر طريقة دفع مفعلة قبل حفظ خيار إنشاء طلب في المتجر.",
  adminSallaOrderShippingCompany: "شركة التوصيل عند إنشاء طلب المتجر",
  adminSallaOrderShippingCompanyPlaceholder: "اختر شركة توصيل مفعلة",
  adminSallaOrderShippingCompanyHint: "تظهر هنا شركات التوصيل المفعلة في المتجر. تأكد من تفعيل صلاحية الشحن في التطبيق.",
  adminSallaOrderShippingCompanyRequired: "اختر شركة توصيل مفعلة قبل حفظ خيار إنشاء طلب في المتجر.",
  adminSallaOrderShippingCost: "تكلفة التوصيل المعروضة",
  adminSallaOrderShippingCostHint: "تظهر هذه القيمة للعميل ضمن إجمالي الطلب في موقعنا.",
  adminSallaOrderShipToCountryId: "معرف الدولة",
  adminSallaOrderShipToCityId: "معرف المدينة",
  adminSallaOrderShipToDistrictId: "معرف الحي",
  adminSallaOrderShipToAddress: "عنوان التوصيل",
  adminSallaOrderShipToAddressLine: "تفاصيل العنوان",
  adminSallaOrderShipToPostalCode: "الرمز البريدي",
  adminSallaOrderShippingAddressHint: "هذه البيانات ترسل مع طلب المتجر عند استخدام طريقة التوصيل. يمكن تعديلها لاحقا عند دعم عنوان العميل.",
  adminSallaOrderShippingAddressRequired: "أدخل معرف الدولة والمدينة وعنوان التوصيل قبل حفظ خيار إنشاء طلب في المتجر.",
  adminOrdersTotal: "إجمالي الطلبات",
  adminOrdersStoreOrders: "طلبات المتجر",
  adminOrdersInternalRequests: "طلبات داخلية",
  adminOrdersLoadFailed: "تعذر جلب طلبات المتجر.",
  adminOrdersNoData: "لا توجد طلبات حتى الآن",
  adminOrderTypeStore: "طلب متجر",
  adminOrderTypeInternal: "طلب داخلي",
  adminOrdersUnknownCustomer: "عميل غير محدد",
  adminOrdersAmount: "المبلغ",
  adminOrdersItems: "القطع",
  adminOrdersPhone: "الجوال",
  adminOrdersStoreOrderNumber: "رقم الطلب",
  adminOrdersOpenInDashboard: "فتح في لوحة المتجر",
  adminOrdersOpenCustomerLink: "رابط العميل",
  adminOrdersOpenPaymentLink: "رابط الدفع",
  adminOrderStatusPending: "قيد المراجعة",
  adminOrderStatusStoreOrderCreated: "تم إنشاء طلب المتجر",
  adminOrderStatusCompleted: "مكتمل",
  adminOrderStatusCancelled: "ملغي",
  adminOrderStatusUnknown: "حالة غير معروفة",
  adminSallaTimezone: "المنطقة الزمنية",
  adminSallaSyncInterval: "كل كم تتم المزامنة",
  adminSallaLastStarted: "آخر بداية مزامنة",
  adminSallaLastCompleted: "آخر اكتمال مزامنة",
  adminSallaNextRun: "المزامنة القادمة",
  adminSallaProductPullType: "نوع المنتجات التي يتم سحبها",
  adminSallaActiveOnly: "سحب المنتجات المفعلة فقط",
  adminSallaAllProducts: "سحب كل المنتجات",
  adminSallaLocalStockThreshold: "حد المخزون المحلي",
  adminSallaLocalStockThresholdHint: "إذا كانت كمية المنتج في المتجر أقل من أو تساوي هذا الرقم، سيتم حفظ كميته عندنا كصفر حتى لا يظهر في التوصيات.",
  adminSallaCategoriesNeedConnection: "لا تظهر تصنيفات المتجر إلا بعد ربط التطبيق بنجاح واستقبال بيانات التثبيت .",
  adminSallaCategories: "تصنيفات المتجر",
  adminSallaCategoriesHint: "اتركها فارغة لسحب كل التصنيفات، أو اختر تصنيفات محددة فقط.",
  adminClearSelection: "مسح الاختيار",
  adminSallaNoCategories: "لا توجد تصنيفات محملة من المتجر بعد. تأكد من تثبيت التطبيق ووصول التوكن.",
  adminSelectAgeGroup: "اختر الفئة العمرية",
  adminSelectCategory: "اختر الركن",
  adminMediaTabIcon: "أيقونات",
  adminMediaTabSvg: "SVG",
  adminMediaTabImage: "صور",
  adminMediaEmpty: "لا توجد وسائط بعد",
  adminMediaSelected: "المحدد",
  adminMediaUploadFailed: "تعذر رفع الملف",
  adminMediaSearchPlaceholder: "بحث عن أيقونة أو ملف...",
  adminMediaCategoryChildDev: "أيقونات نمو الطفل (منسقة)",
  adminMediaCategoryTabler: "أيقونات Tabler",
  adminMediaCategoryLucide: "أيقونات Lucide",
  adminMediaCategoryAll: "جميع المكتبات",
  adminMediaNoIcons: "لا توجد أيقونات",
  adminMediaShowingIcons: "يظهر أول {{visible}} أيقونة فقط من إجمالي {{total}}. اكتب في البحث للتصفية.",
  adminIconPreview: "المعاينة",
  adminActive: "مفعلة",
  adminInactive: "غير مفعلة",
  adminProductId: "معرف المنتج",
  adminProductPrice: "السعر",
  adminProductStock: "المخزون",
  adminMappingProduct: "المنتج",
  adminMappingCategory: "الركن",
  adminMappingAgeGroup: "الفئة المستهدفة",
  dbColSallaProductId: "معرف المنتج في المتجر",
  dbColSku: "رمز المنتج (SKU)",
  dbColPrice: "السعر",
  dbColImageUrl: "رابط الصورة",
  dbColStockQuantity: "الكمية / المخزون",
  dbColNameAr: "اسم المنتج (عربي)",
  dbColNameEn: "اسم المنتج (إنجليزي)",

  // Account Page
  myAccount: "حسابي",
  myChildren: "أطفالي",
  reports: "التقارير",
  myOrders: "طلباتي",
  notifications: "الإشعارات",
  settings: "الإعدادات",
  born: "تاريخ الميلاد",
  age: "العمر",
  lastAssessment: "آخر تقييم",
  newAssessment: "تقييم جديد",
  addChild: "إضافة طفل",
  allChildren: "جميع الأطفال",
  noReportsYet: "لا توجد تقارير بعد",
  noOrdersYet: "لا توجد طلبات بعد",
  accountOrderTypeStore: "طلب متجر",
  accountOrderTypeInternal: "طلب داخلي",
  accountOrderStatusPending: "قيد المراجعة",
  accountOrderStatusStoreOrderCreated: "تم إنشاء طلب المتجر",
  accountOrderStatusCompleted: "مكتمل",
  accountOrderStatusCancelled: "ملغي",
  accountOrderStatusUnknown: "حالة غير معروفة",
  accountOrderUnknownChild: "طفل غير محدد",
  accountOrderAmount: "المبلغ",
  accountOrderItems: "القطع",
  accountOrderPaymentLink: "فتح رابط الدفع",
  accountOrderDetailsLink: "تفاصيل الطلب",
  noNotifications: "لا توجد إشعارات",

  // Footer
  footerRights: "جميع الحقوق محفوظة.",
  footerTagline: "نُمكّن الأهل برؤى نمو ذكية.",
};
